'use-strict';

import Modal from '../utils/modal';

const distributorRules = new Modal()
    .setTriggerSelector('.distributor-rules-modal-trigger')
    .setModalId('distributor-rules-modal')
    .setModalWrapperId('distributor-rules-modal-wrapper')
    .setUpListenersForm();
distributorRules.render();



// WEBPACK FOOTER //
// ./assets/js/front/b2b-contact.js